import React, {Component} from "react";
import Comment from "../../../common/comments/comment.component";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryCircuitActions } from "../../../../store/external/inventory/circuit.reducer";
import { Loading } from "../../../common/loading";
import { MAX_LENGTH } from "../../../../../app/constants/external-constants";

class CircuitComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        }
    
    }

    componentDidMount() {
        const { getInventoryCircuitComments, inventoryCircuit } = this.props;
        getInventoryCircuitComments(this.props.circuitId, inventoryCircuit?.commentsPage)
        .then(()=>{ this.setState({isLoading:false})
        });
    }

    postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postInventoryCircuitComments } = this.props;
        postInventoryCircuitComments(this.props.circuitId, attachedFilename, attachedFileData, commentDescription)
            .then(()=>{ this.setState({isLoading:false})
            });       
    }


    handleDeleteCircuitComments = async (circuitId) => {
        this.setState({isLoading:true});
        const { deleteInventoryCircuitComments, getInventoryCircuitComments, inventoryCircuit, resetInventoryCircuitComments } = this.props;
        await deleteInventoryCircuitComments(circuitId, this.props.circuitId);
        await resetInventoryCircuitComments();
        await getInventoryCircuitComments(this.props.circuitId, 1, inventoryCircuit?.inventoryCircuitComments?.length).then(()=>{
            this.setState({isLoading:false})
        });
        this.setState({show : false})
    }

    handleLoadMore = async () => {
        const { getInventoryCircuitComments, inventoryCircuit, circuitId } = this.props;
        await getInventoryCircuitComments(circuitId, inventoryCircuit.commentsPage + 1)
    }

    componentWillUnmount() {
        const { resetInventoryCircuitComments } = this.props;
        resetInventoryCircuitComments();
    }


    render(){
        if(this.state.isLoading) {
          return <Loading />
        }

        return(
            <Comment 
                commentList={this.props.inventoryCircuit.inventoryCircuitComments}
                addCommentAction={this.postComment.bind(this)}
                deleteCommentAction={this.handleDeleteCircuitComments.bind(this)}
                maxLength={MAX_LENGTH.limit_500}
                handleLoadMore={this.handleLoadMore}
                hasMoreComments={this.props?.inventoryCircuit?.hasMoreComments}
                isReadOnly={this.props.isReadOnly}
                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                isReadAndWrite={this.props.isReadAndWrite}
            />
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuit } = state;
        const { inventoryCircuitFormA } = state.form;

        return {
            inventoryCircuit,
            inventoryCircuitFormA
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitActions),
        dispatch
    )
)(CircuitComment);